import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  listPhoneReleaseManifests,
  type PhoneReleaseManifest,
} from "@/lib/phone-runtime-changelog";

const releases = listPhoneReleaseManifests();

function formatReleaseDate(value: string | null): string {
  if (!value) return "未知";
  // Date-only (YYYY-MM-DD) or full ISO.
  const parsed = value.length === 10 ? new Date(`${value}T00:00:00Z`) : new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

function ReleaseRow({ release }: { release: PhoneReleaseManifest }) {
  return (
    <li className="flex flex-col gap-2 border-b border-border px-4 py-4 last:border-b-0 sm:flex-row sm:items-start sm:gap-6">
      <div className="flex w-full shrink-0 flex-col gap-1 sm:w-36">
        <span className="font-mono text-sm font-medium tabular-nums">
          {release.version}
        </span>
        <span className="text-xs text-muted-foreground">
          {formatReleaseDate(release.date)}
        </span>
        {release.validatorId ? (
          <Badge variant="outline" className="w-fit">
            {release.validatorId}
          </Badge>
        ) : null}
      </div>
      <p className="min-w-0 flex-1 text-sm leading-relaxed text-foreground">
        {release.notes || (
          <span className="text-muted-foreground">无说明</span>
        )}
      </p>
    </li>
  );
}

export function PhoneRuntimeChangelog() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>版本 changelog</CardTitle>
        <CardDescription>
          来自 packages/phone/releases 下各版本的 manifest.json，按版本从新到旧排列。共{" "}
          {releases.length} 个版本。
        </CardDescription>
      </CardHeader>
      <CardContent className="px-0 pb-0">
        {releases.length === 0 ? (
          <p className="px-4 pb-4 text-sm text-muted-foreground">
            未找到任何 release manifest。
          </p>
        ) : (
          <ul>
            {releases.map((release) => (
              <ReleaseRow key={release.version} release={release} />
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
